import { render, staticRenderFns } from "./branch-sales.vue?vue&type=template&id=29b485c2&scoped=true"
import script from "./branch-sales.vue?vue&type=script&lang=js"
export * from "./branch-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b485c2",
  null
  
)

export default component.exports